<div class="back">
  <button mat-flat-button type="button"  color="accent" (click)="navigate()">
  <mat-icon>navigate_before</mat-icon>
  Torna indietro
</button>
</div>
<h1 class="title">ASSEGNAZIONE TURNI DEGLI OPERATORI</h1>
<div class="filter-container">
  <form class="filter-form" [formGroup]="formFilters">
    <div class="filter-fields">
      <div class="div">
        <p class="title-filter">Seleziona la struttura:</p>
        <mat-form-field appearance="outline" class="filter-field">
          <mat-select formControlName="establishment" (valueChange)="onChangeStructure($event)">
            @for(establishment of establishmentOptions ; track $index){
              <mat-option  [value]="establishment">
                {{ establishment.name }} - {{establishment.address}} , {{establishment.cap}} ,{{establishment.city}}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>

      @if(listOperators.length){
        <div class="div">
          <p class="title-filter">Nome: *</p>
          <mat-form-field appearance="outline" class="filter-field">
            <input matInput formControlName="name" type="text" (ngModelChange)="applyFilters()" />
          </mat-form-field>
        </div>
        <div class="div">
          <p class="title-filter">Cognome: *</p>
          <mat-form-field appearance="outline" class="filter-field">
            <input matInput formControlName="surname" type="text" (ngModelChange)="applyFilters()"/>
          </mat-form-field>
        </div>
      }
    </div>
  </form>
</div>

<!-- TABELLA -->
 <div class="mat-elevation-z8 full-width">
  <table mat-table [dataSource]="dataSource">
    <!-- columns -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef> Nome </th>
      <td mat-cell *matCellDef="let element"> {{element.name | titlecase }} </td>
    </ng-container>

    <ng-container matColumnDef="surname">
      <th mat-header-cell *matHeaderCellDef> Cognome </th>
      <td mat-cell *matCellDef="let element"> {{element.surname | titlecase}} </td>
    </ng-container>

    <ng-container matColumnDef="tax-code">
      <th mat-header-cell *matHeaderCellDef> Codice fiscale </th>
      <td mat-cell *matCellDef="let element"> {{element.tin ?  (element.tin | uppercase) : "-"}}  </td> 
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef> Email </th>
      <td mat-cell *matCellDef="let element"> {{element.email}} </td>
    </ng-container>

    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef> Numero di telefono </th>
      <td mat-cell *matCellDef="let element"> {{element.phone}} </td>
    </ng-container>

    <ng-container matColumnDef="active">
      <th mat-header-cell *matHeaderCellDef> Attivo  </th>
      <td mat-cell *matCellDef="let element"> {{ element.active ? 'SI':'NO'}} </td>
    </ng-container>

    <!-- actions -->
    <ng-container matColumnDef="azioni">
      <th class="action-th" mat-header-cell *matHeaderCellDef> Azioni </th>
      <td class="action-td" mat-cell *matCellDef="let element">
        <button mat-icon-button (click)="detailOperator(element)">
          <mat-icon>info</mat-icon>
        </button>
      </td>
    </ng-container>


    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- AGGIUNTO: riga mostrata se non ci sono dati -->
    <tr *matNoDataRow>
      <td [attr.colspan]="displayedColumns.length">
        <div class="no-data-wrapper">
          <mat-icon>info</mat-icon>
          <span>Nessun elemento.</span>
        </div>
      </td>
    </tr>

  </table>

  <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
  </mat-paginator>
</div>
